import Dashboard from '@local/web-design-system-2/icons/Dashboard';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import UpdateIcon from '@mui/icons-material/Update';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import type { ReactNode } from 'react';
import { useState } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';

import imagoPinkWhite from 'src/assets/imagoPinkWhite.svg';
import { ROUTES } from 'src/utils/strings';

import { ProfileFooter } from './profile-footer/ProfileFooter';
import { SideBarNavItem } from './side-bar-nav-item/SideBarNavItem';
import { i18n } from './SideBar.i18n';
import { useStyles } from './SideBar.styles';

type NavItem = {
    key: string;
    label: MessageDescriptor;
    path: string;
    icon: ReactNode;
};

const NAV_ITEMS: NavItem[] = [
    {
        key: 'dashboard',
        label: i18n.dashboardLabel,
        path: ROUTES.ROOT_PATH,
        icon: <Dashboard />,
    },
    {
        key: 'instances',
        label: i18n.instancesLabel,
        path: ROUTES.INSTANCES,
        icon: <ListAltIcon />,
    },
    {
        key: 'users',
        label: i18n.usersLabel,
        path: ROUTES.USERS,
        icon: <PeopleAltIcon />,
    },
    {
        key: 'support-packages',
        label: i18n.supportPackagesLabel,
        path: ROUTES.SUPPORT_PACKAGES,
        icon: <SupportAgentIcon />,
    },
    {
        key: 'active-versions',
        label: i18n.activeVersionsLabel,
        path: ROUTES.ACTIVE_VERSIONS,
        icon: <UpdateIcon />,
    },
];

export const SideBar = () => {
    const { classes, cx } = useStyles();
    const intl = useIntl();
    const [expanded, setExpanded] = useState(false);

    return (
        <Drawer
            variant="permanent"
            className={cx(
                classes.drawer,
                expanded ? classes.drawerExpanded : classes.drawerCollapsed,
            )}
            classes={{ paper: classes.drawerPaper }}
            onMouseEnter={() => setExpanded(true)}
            onMouseLeave={() => setExpanded(false)}
            automation-id="side-bar"
        >
            <div className={classes.logoContainer}>
                <img
                    src={imagoPinkWhite}
                    alt={intl.formatMessage(i18n.logoAlt)}
                    className={cx(
                        classes.logoReveal,
                        expanded ? classes.logoRevealExpanded : classes.logoRevealCollapsed,
                    )}
                />
            </div>
            <List className={classes.navList} disablePadding>
                {NAV_ITEMS.map((item) => (
                    <SideBarNavItem
                        key={item.key}
                        itemKey={item.key}
                        label={intl.formatMessage(item.label)}
                        path={item.path}
                        icon={item.icon}
                        expanded={expanded}
                    />
                ))}
            </List>
            <div className={classes.footer}>
                <ProfileFooter expanded={expanded} />
            </div>
        </Drawer>
    );
};
